import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class AppConfigurationService {
  constructor() {}

  getConfigurationSetting = (key: string): Promise<{ value: number }> => {
    switch (key) {
      case "CloudDemoTraining:DemoDeleteInterval":
        return new Promise(resolve => {
          resolve({ value: 96 });
        });
      case "CloudDemoTraining:DemoSleepInterval":
        return new Promise(resolve => {
          resolve({ value: 24 });
        });
    }
  };
}
